import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { getCardImageProps } from "./cardImages";
export default function CardImage(t0) {
  const $ = _c(13);
  const {
    card,
    fallbackImage: t1,
    className: t2,
    imgClassName: t3
  } = t0;
  const fallbackImage = t1 === undefined ? null : t1;
  const className = t2 === undefined ? "" : t2;
  const imgClassName = t3 === undefined ? "h-full w-full object-cover" : t3;
  const [failed, setFailed] = useState(false);
  let t4;
  if ($[0] !== card || $[1] !== fallbackImage) {
    t4 = getCardImageProps(card, fallbackImage);
    $[0] = card;
    $[1] = fallbackImage;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const image = t4;
  let t5;
  if ($[3] !== fallbackImage) {
    t5 = getCardImageProps(null, fallbackImage);
    $[3] = fallbackImage;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const fallback = t5;
  const src = failed ? fallback.src : image.src;
  const alt = failed ? fallback.alt : image.alt;
  if (!src) {
    return null;
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setFailed(true);
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== alt || $[7] !== imgClassName || $[8] !== src) {
    t7 = <img src={src} alt={alt} className={imgClassName} loading="lazy" decoding="async" onError={t6} />;
    $[6] = alt;
    $[7] = imgClassName;
    $[8] = src;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== className || $[11] !== t7) {
    t8 = <div className={className}>{t7}</div>;
    $[10] = className;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}